import PropTypes from "prop-types";
import React from "react";

import { useSelector } from "react-redux";
// import Title from '../components/Title'
import Navbar from "../components/Navbar";
import reducer from "../reducer";

const MessageRow = ({ name, ref_id, total, content }) => {
  const handleClick = () => {
    location = `#消息/${name}/${ref_id}`;
  };

  return (
    <div className="card user-radius mt-2 shadow">
      <div className="card-body p-3">
        <div className="row" onClick={handleClick} aria-hidden="true">
          {/* <div
        style={{
          background: 'url(lib/img/u679.svg)',
          backgroundSize: '100% 100%',
          paddingRight: 0
        }}
        className="col-2">
        {

        } &nbsp;
      </div> */}
          <div className="col">
            <div className="row ">
              <div className="col">
                <h6 className="pull-left">
                  <strong>{name}</strong>
                  &nbsp;
                  {total !== 0 ? <span className="badge badge-danger">{total}</span> : <></>}
                </h6>
              </div>
            </div>
            <span className="text-muted">{content}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

MessageRow.propTypes = {
  name: PropTypes.string.isRequired,
  ref_id: PropTypes.number.isRequired,
  total: PropTypes.number,
  content: PropTypes.string,
};

MessageRow.defaultProps = {
  name: "",
  ref_id: 0,
  total: 0,
  content: "",
};

export default function List() {
  const auth = useSelector((state) => state.auth);
  // const [chatList, setChatList] = React.useState([]);
  const [state, dispatch] = React.useReducer(reducer, {
    UNREAD: [],
    READ: [],
    conversation: [],
    PROGRESS: 0,
  });
  const handleLogIn = async () => {
    location.href = "#/登录";
  };

  if (0 === auth.id) location.href = "#/登录?id=1";

  React.useEffect(() => {
    document.title = "消息";
  }, []);

  React.useEffect(() => {
    // let url = [
    //   '/api/miscellaneous/message',
    //   '?option=by-ref_id2-category-tag-status',
    //   `&ref_id2=${auth.id}`,
    //   '&category=咨询企业',
    //   '&tag=个人用户',
    //   '&status=',
    // ];
    // fetch(url.join(''))
    //   .then((response) => response.json())
    //   .then((data) => {
    //     console.log(data, 'message');
    //     if (0 === data.length) return;
    //     let lt = [];
    //     data.forEach((current) => {
    //       let i = lt.findIndex((element) => (element.ref_id = current.ref_id));
    //       if (i === -1) {
    //         lt.push({ ...current, qty: 1 });
    //       } else {
    //         lt[i].qty += 1;
    //       }
    //     });
    //     dispatch({ type: 'set', payload: { key: 'conversation', value: lt } });
    //     dispatch({ type: 'set', payload: { key: 'PROGRESS', value: 1 } });
    //   });
  }, []);

  React.useEffect(() => {
    if (0 === state.PROGRESS) {
      const url = [
        "/api/miscellaneous/message",
        "?option=group-ref_id-by-ref_id2-tag-category-status",
        `&ref_id2=${auth.id}`,
        "&tag=企业用户",
        "&category=咨询企业",
        "&status=未读",
      ];
      fetch(url.join(""))
        .then((response) => response.json())
        .then((data) => {
          console.log(data);
          dispatch({ type: "set", payload: { key: "UNREAD", value: data } });
          dispatch({
            type: "set",
            payload: { key: "PROGRESS", value: state.PROGRESS + 1 },
          });
        });
    } else if (1 === state.PROGRESS) {
      const list = state.UNREAD.map((current) => current.ref_id).join(",");
      const url = [
        "/api/miscellaneous/message",
        "?option=group-ref_id-by-ref_id2-tag-category-exclude_list",
        `&ref_id2=${auth.id}`,
        "&tag=企业用户",
        "&category=咨询企业",
        `&list=${list || 0}`,
      ];
      fetch(url.join(""))
        .then((response) => response.json())
        .then((data) => {
          console.log(data);
          dispatch({ type: "set", payload: { key: "READ", value: data } });
          dispatch({
            type: "set",
            payload: { key: "PROGRESS", value: state.PROGRESS + 1 },
          });
        });
    } else if (state.PROGRESS === 2) {
      const a = state.UNREAD.map((current) => current.ref_id);
      const b = state.READ.map((current) => current.ref_id);
      const url = [
        "/api/miscellaneous/message",
        "?option=group-ref_id2-by-ref_id-tag-category-exclude_list",
        `&ref_id=${auth.id}`,
        "&tag=个人用户",
        "&category=咨询企业",
        `&list=${a.concat(b).join(",")}`,
      ];
      fetch(url.join(""))
        .then((response) => response.json())
        .then((data) => {
          console.log(data);
          dispatch({
            type: "set",
            payload: { key: "READ", value: state.READ.concat(data) },
          });
          dispatch({
            type: "set",
            payload: { key: "PROGRESS", value: state.PROGRESS + 1 },
          });
        });
    } else if (state.PROGRESS === 3) {
      const a = state.UNREAD.map((current) => current.ref_id);
      const b = state.READ.map((current) => {
        if (current.tag === "企业用户") return current.ref_id;
        if (current.tag === "个人用户") return current.ref_id2;
      });
      fetch(
        // `/api/biz/employer?option=user-by-user-id-list&list=${a.concat(b).join(',') || 0
        // }`,
        `/gin-api/employer-user?option=filterBy-ids&ids=${a.concat(b).join(",") || 0}`,
      )
        .then((response) => response.json())
        .then((data) => {
          console.log(data);
          const lt = [];
          state.UNREAD.forEach((current) => {
            const r = data.find((element) => element.id === current.ref_id);
            if (null !== r)
              lt.push({
                id: current.id,
                ref_id: r.id,
                name: r.name,
                dtime: current.dtime,
                status: current.status,
                tag: current.tag,
                content: current.content,
                qty: current.qty,
              });
            else
              lt.push({
                id: current.id,
                ref_id: 0,
                name: "",
                dtime: current.dtime,
                status: current.status,
                tag: current.tag,
                content: current.content,
                qty: current.qty,
              });
          });
          dispatch({ type: "set", payload: { key: "UNREAD", value: lt } });
          const ltRead = [];
          state.READ.forEach((current) => {
            const r = data.find((element) => element.id === current.ref_id);
            if (undefined !== r)
              ltRead.push({
                id: current.id,
                ref_id: r.id,
                name: r.name,
                dtime: current.dtime,
                status: current.status,
                tag: current.tag,
                content: current.content,
              });
            // else
            //   ltRead.push({
            //     id: current.id,
            //     ref_id: 0,
            //     name: '',
            //     dtime: current.dtime,
            //     status: current.status,
            //     tag: current.tag,
            //     content: current.content,
            //   });
          });
          dispatch({ type: "set", payload: { key: "READ", value: ltRead } });
          dispatch({
            type: "set",
            payload: { key: "PROGRESS", value: state.PROGRESS + 1 },
          });
        });
    }
  }, [state.PROGRESS]);

  return (
    <>
      {0 === auth.id ? (
        <div className="container-fluid">
          <div className="chat-login">
            <h6>登录后可以查看消息</h6>
            <button
              type="button"
              style={{ width: "25%" }}
              className="btn btn-block mx-auto rounded-pill button-background text-white font-weight"
              onClick={handleLogIn}
            >
              登&nbsp;录
            </button>
          </div>
        </div>
      ) : (
        <div className="container-fluid">
          {state.PROGRESS === 4 && (
            <div>
              {state.UNREAD.map((current) => (
                <MessageRow
                  key={current.id}
                  total={current.qty}
                  ref_id={current.ref_id}
                  name={current.name}
                  content={current.content}
                />
              ))}
            </div>
          )}
          {state.PROGRESS === 4 && (
            <div>
              {state.READ.map((current) => (
                <MessageRow
                  key={current.id}
                  total={0}
                  ref_id={current.ref_id}
                  name={current.name}
                  content={current.content}
                />
              ))}
            </div>
          )}
          {state.UNREAD.length === 0 && state.READ.length === 0 && (
            <div className="chat-login">
              <h6>没有新消息</h6>
            </div>
          )}
          {/* {2 === state.PROGRESS && 0 < state.conversation.length ? (
            <div>
              {state.conversation.map((current) => (
                <MessageRow
                  key={current.id}
                  total={current.qty}
                  ref_id={current.ref_id}
                  name={current.name}
                  content={current.content}
                />
              ))}
            </div>
          ) : (
            <div className="chat-login">
              <h6>您还没有新消息</h6>
            </div>
          )} */}
        </div>
      )}
      <Navbar category="消息" />
    </>
  );
}
